/**
 * @generated SignedSource<<b4c0342e7b77cd4f427ec90fd25ed2cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitDetailsContent_nftItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useIsPrimarySale_nftItem">;
  readonly " $fragmentType": "SplitDetailsContent_nftItem";
};
export type SplitDetailsContent_nftItem$key = {
  readonly " $data"?: SplitDetailsContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SplitDetailsContent_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsPrimarySale_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "6b3e17589f80c76e49b86b3886a66a73";

export default node;
